/**
 * Check is the code run in test environment
 */
export default process.env.NODE_ENV === 'test';
